/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: true },
      tokens: {
        backgroundColor: '#f5f5f7',
        color: '#2b3145',
        iconColor: '#2b3145',
        iconSize: 26
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        color: '#cdcfd5',
        iconColor: '#cdcfd5',
        iconSize: 22
      }
    },
    { if: { hover: true }, tokens: { iconSize: 26 } }
  ],
  tokens: {
    activeColor: '#394056',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    color: '#6a7080',
    fontName: 'SofiaPro',
    fontWeight: '400',
    iconColor: '#6a7080',
    iconSize: 24,
    lineHeight: 1.3333333333333333,
    paddingBottom: 4,
    paddingTop: 4
  }
}
export default theme
